(function () {
  if (window.location.pathname !== '/pages/wishlist') {
    return;
  }

  function alignWishlistPage() {
    const host = document.querySelector('.gw-wl-page-placeholder');

    if (!host || !host.shadowRoot) {
      return false;
    }

    if (host.shadowRoot.getElementById('carpolish-wishlist-layout-fix')) {
      return true;
    }

    const style = document.createElement('style');
    style.id = 'carpolish-wishlist-layout-fix';
    style.textContent = '.gw-wl-page-wrapper { box-sizing: border-box !important; margin-left: 0 !important; width: 100% !important; max-width: 100% !important; }\n@media (max-width: 768px) {\n  .gw-wl-product-list { grid-template-columns: repeat(2, minmax(0, 1fr)) !important; width: 100% !important; max-width: 100% !important; }\n  .gw-wl-product-card,\n  .gw-wl-product-card__content,\n  .gw-wl-product-card__actions,\n  .gw-wl-product-card__btn-wrap { box-sizing: border-box !important; min-width: 0 !important; max-width: 100% !important; }\n  .gw-wl-product-card__title-link,\n  .gw-wl-product-card__action-btn { max-width: 100% !important; overflow-wrap: anywhere !important; white-space: normal !important; text-align: center !important; }\n}';
    host.shadowRoot.appendChild(style);
    return true;
  }

  if (alignWishlistPage()) {
    return;
  }

  const observer = new MutationObserver(function () {
    if (alignWishlistPage()) {
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.setTimeout(function () {
    observer.disconnect();
  }, 10000);
})();

$(document).ready(function(){
  //footer button enabled-disabled on click
  if(document.getElementById('footer_tandc')){
     document.getElementById('footer_tandc').addEventListener('change', function() {
        var button = document.getElementById('footer_button');
        button.disabled = !button.disabled;
     });
  }
  let contactT_and_C = document.querySelector("#contact_form #tandc") || null;
  if(contactT_and_C){
    contactT_and_C.addEventListener("change",function(e){
      document.querySelector("#contact_form .form__submit").toggleAttribute("disabled");
    });
  }

  var btn = $('#backtotop');
  
  $(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('show');
  } else {
    btn.removeClass('show');
  }
  });
  
  btn.on('click', function(e) {
  e.preventDefault();
  $('html, body').animate({scrollTop:0}, '300');
  });

  //Show Review widget on review click
  const jdgm_review = document.querySelector('.jdgm-widget');
  if(jdgm_review){
    jdgm_review.addEventListener('click',function(e){
      document.querySelector('.review-faq-title').click();
    });
  }

  //Wishlist Mobile Menu
  const drawer_wishlist_link = document.querySelector('.drawer_wishlist_link');
  if(drawer_wishlist_link){
    drawer_wishlist_link.addEventListener('click',function(e){
      document.querySelector('.header__mobile-nav-toggle').click();
    });
  }

  var soldout_btns = document.querySelectorAll(".button--disabled");
  // console.log("soldout_btns",soldout_btns);
  soldout_btns.forEach(soldoutBtn => {
    soldoutBtn.addEventListener('click', function(){
      console.log("soldoutBtn",soldoutBtn);
      if(!soldoutBtn.hasAttribute("data-action")){
       if(document.querySelector(".klaviyo-bis-trigger"))document.querySelector(".klaviyo-bis-trigger").click();
      }
    });
  });
  
  //Menu dropdown
  $(document).on('click',".menu_dropdown_arrow",function(){
    $(this).parent(".nav-dropdownlink-wrap").siblings(".custom_submenu").slideToggle();
    $(this).toggleClass("active");
  });

  //blog Page Filter
  const dropdownTitle = document.querySelector('.dropdown-title');
  const dropdown = document.querySelector('.blog-dropdown');
  if(dropdownTitle && dropdown){
    dropdownTitle.addEventListener('click',function(e){
      if (dropdown.classList.contains('active')) {
        dropdown.classList.remove('active');
        this.classList.remove('active');
      } else {
        dropdown.classList.add('active');
        this.classList.add('active');
      }
    });
    document.addEventListener('click', function (event) {
      // console.log("event.target",event.target);
      if(event.target != dropdown && !event.target.closest(".blog-dropdown")){
        if (event.target !== dropdownTitle){
          dropdown.classList.remove('active');
          dropdownTitle.classList.remove('active');
        }
      }
    });
  }

   $(".job-imagetext-top .section-btn a").on('click', function(event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 160
      }, 800, function(){
      //  window.location.hash = hash;
      });
    }
  });
  
  // Show password
  const togglePassword = document.querySelector('#togglePassword');
  const password = document.querySelector('#CustomerPassword');
  if(togglePassword != null)
  {
    togglePassword.addEventListener('click', function (e) {
      const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
      password.setAttribute('type', type);
      this.classList.toggle('show-password');
    });
  }

  // Show password
  const togglePassword1 = document.querySelector('#CreatePassword');
  const password1 = document.querySelector('#PasswordConfirmation');
  if(togglePassword1 != null)
  {
    togglePassword1.addEventListener('click', function (e) {
      const type = password1.getAttribute('type') === 'password' ? 'text' : 'password';
      password1.setAttribute('type', type);
      this.classList.toggle('show-password');
    });
  }
  // Show password
  const togglePassword2 = document.querySelector('#confirm-password');
  const password2 = document.querySelector('#ResetPassword');
  if(togglePassword2 != null) {
    togglePassword2.addEventListener('click', function (e) {
      const type = password2.getAttribute('type') === 'password' ? 'text' : 'password';
      password2.setAttribute('type', type);
      this.classList.toggle('show-password');
    });
  }

  $('.answer-image-slider').slick({
    infinite: true,
    slidesToShow:1,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });
  
  
  $('.testimonial-slider').slick({
    infinite: true,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    centerPadding: '50px',
    centerMode: true,
    prevArrow: $('.testimonial-slick-prev'),
    nextArrow: $('.testimonial-slick-next'),
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 2.5
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true
        }
      }
    ]
  });

  $('.article_product_list .product-list').slick({
     infinite: false,
      slidesToShow:4,
      slidesToScroll: 1,
      arrows:true,
  });
  if ($(window).width() < 1200){
     $('.announcement-bar .announcement-col').slick({
      autoplay:true,
      infinite: true,
      slidesToShow:1,
      slidesToScroll: 1,
      arrows:false,
      dots: false,
    });
    $('.services-icon-section .text-with-icons, .jobtop-icon-section .text-with-icons').slick({
      infinite: true,
      slidesToShow:3,
      slidesToScroll: 1,
      centerMode: true,
      prevArrow:'<button class="custom-slick-prev custom-slick-arrow" type="button"><svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.543 4.52899H2.205L4.33 6.65399C4.45134 6.77533 4.51951 6.93988 4.51951 7.11148C4.51951 7.28308 4.45134 7.44766 4.33 7.569C4.20867 7.69034 4.0441 7.75848 3.8725 7.75848C3.70091 7.75848 3.53634 7.69034 3.415 7.569L1.48 5.63098L0.188005 4.33701C0.0679482 4.21601 0.000579834 4.05244 0.000579834 3.88199C0.000579834 3.71153 0.0679482 3.548 0.188005 3.427L3.415 0.196991C3.47508 0.136911 3.54641 0.0892471 3.62491 0.0567322C3.70341 0.0242172 3.78754 0.00747681 3.8725 0.00747681C3.95747 0.0074768 4.0416 0.0242172 4.1201 0.0567322C4.1986 0.0892471 4.26992 0.136911 4.33 0.196991C4.39008 0.257071 4.43774 0.328393 4.47026 0.406891C4.50277 0.485389 4.51951 0.569514 4.51951 0.65448C4.51951 0.739446 4.50277 0.823602 4.47026 0.9021C4.43774 0.980598 4.39008 1.05192 4.33 1.112L2.2 3.237H13.58C13.6676 3.23491 13.7548 3.25062 13.8361 3.28323C13.9175 3.31584 13.9914 3.36466 14.0533 3.4267C14.1153 3.48873 14.1639 3.56269 14.1964 3.6441C14.2289 3.72552 14.2445 3.8127 14.2422 3.90033C14.24 3.98796 14.22 4.07422 14.1834 4.15387C14.1468 4.23352 14.0944 4.30492 14.0294 4.36371C13.9644 4.4225 13.8881 4.46747 13.8052 4.49588C13.7222 4.52429 13.6344 4.53555 13.547 4.52899H13.543Z" fill="#E80918"/></svg></button>',
      nextArrow:'<button class="custom-slick-next custom-slick-arrow" type="button"><svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.700006 4.52899H12.038L9.91301 6.65399C9.79167 6.77533 9.7235 6.93988 9.7235 7.11148C9.7235 7.28308 9.79167 7.44766 9.91301 7.569C10.0343 7.69034 10.1989 7.75848 10.3705 7.75848C10.5421 7.75848 10.7067 7.69034 10.828 7.569L12.763 5.63098L14.055 4.33701C14.1751 4.21601 14.2424 4.05244 14.2424 3.88199C14.2424 3.71153 14.1751 3.548 14.055 3.427L10.828 0.196991C10.7679 0.136911 10.6966 0.0892471 10.6181 0.0567322C10.5396 0.0242172 10.4555 0.00747681 10.3705 0.00747681C10.2855 0.0074768 10.2014 0.0242172 10.1229 0.0567322C10.0444 0.0892471 9.97309 0.136911 9.91301 0.196991C9.85293 0.257071 9.80527 0.328393 9.77275 0.406891C9.74024 0.485389 9.7235 0.569514 9.7235 0.65448C9.7235 0.739446 9.74024 0.823602 9.77275 0.9021C9.80527 0.980598 9.85293 1.05192 9.91301 1.112L12.043 3.237H0.663007C0.575376 3.23491 0.488235 3.25062 0.406871 3.28323C0.325507 3.31584 0.251618 3.36466 0.189688 3.4267C0.127758 3.48873 0.0790787 3.56269 0.0466051 3.6441C0.0141316 3.72552 -0.001459 3.8127 0.000779152 3.90033C0.0030173 3.98796 0.023037 4.07422 0.0596247 4.15387C0.0962123 4.23352 0.148604 4.30492 0.21362 4.36371C0.278636 4.4225 0.354921 4.46747 0.437843 4.49588C0.520766 4.52429 0.608597 4.53555 0.696007 4.52899H0.700006Z" fill="#E80918"/></svg></button>',
      arrows:true,
      dots: false,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow:2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

 
  if ($(window).width() < 1000){
    function homeProductList(){
      $('.home-product-list .product-list').slick({
        infinite: true,
        slidesToShow:2,
        slidesToScroll: 1,
        arrows:true,
        prevArrow:'<button class="custom-slick-prev custom-slick-arrow" type="button"><svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.543 4.52899H2.205L4.33 6.65399C4.45134 6.77533 4.51951 6.93988 4.51951 7.11148C4.51951 7.28308 4.45134 7.44766 4.33 7.569C4.20867 7.69034 4.0441 7.75848 3.8725 7.75848C3.70091 7.75848 3.53634 7.69034 3.415 7.569L1.48 5.63098L0.188005 4.33701C0.0679482 4.21601 0.000579834 4.05244 0.000579834 3.88199C0.000579834 3.71153 0.0679482 3.548 0.188005 3.427L3.415 0.196991C3.47508 0.136911 3.54641 0.0892471 3.62491 0.0567322C3.70341 0.0242172 3.78754 0.00747681 3.8725 0.00747681C3.95747 0.0074768 4.0416 0.0242172 4.1201 0.0567322C4.1986 0.0892471 4.26992 0.136911 4.33 0.196991C4.39008 0.257071 4.43774 0.328393 4.47026 0.406891C4.50277 0.485389 4.51951 0.569514 4.51951 0.65448C4.51951 0.739446 4.50277 0.823602 4.47026 0.9021C4.43774 0.980598 4.39008 1.05192 4.33 1.112L2.2 3.237H13.58C13.6676 3.23491 13.7548 3.25062 13.8361 3.28323C13.9175 3.31584 13.9914 3.36466 14.0533 3.4267C14.1153 3.48873 14.1639 3.56269 14.1964 3.6441C14.2289 3.72552 14.2445 3.8127 14.2422 3.90033C14.24 3.98796 14.22 4.07422 14.1834 4.15387C14.1468 4.23352 14.0944 4.30492 14.0294 4.36371C13.9644 4.4225 13.8881 4.46747 13.8052 4.49588C13.7222 4.52429 13.6344 4.53555 13.547 4.52899H13.543Z" fill="#E80918"/></svg></button>',
        nextArrow:'<button class="custom-slick-next custom-slick-arrow" type="button"><svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.700006 4.52899H12.038L9.91301 6.65399C9.79167 6.77533 9.7235 6.93988 9.7235 7.11148C9.7235 7.28308 9.79167 7.44766 9.91301 7.569C10.0343 7.69034 10.1989 7.75848 10.3705 7.75848C10.5421 7.75848 10.7067 7.69034 10.828 7.569L12.763 5.63098L14.055 4.33701C14.1751 4.21601 14.2424 4.05244 14.2424 3.88199C14.2424 3.71153 14.1751 3.548 14.055 3.427L10.828 0.196991C10.7679 0.136911 10.6966 0.0892471 10.6181 0.0567322C10.5396 0.0242172 10.4555 0.00747681 10.3705 0.00747681C10.2855 0.0074768 10.2014 0.0242172 10.1229 0.0567322C10.0444 0.0892471 9.97309 0.136911 9.91301 0.196991C9.85293 0.257071 9.80527 0.328393 9.77275 0.406891C9.74024 0.485389 9.7235 0.569514 9.7235 0.65448C9.7235 0.739446 9.74024 0.823602 9.77275 0.9021C9.80527 0.980598 9.85293 1.05192 9.91301 1.112L12.043 3.237H0.663007C0.575376 3.23491 0.488235 3.25062 0.406871 3.28323C0.325507 3.31584 0.251618 3.36466 0.189688 3.4267C0.127758 3.48873 0.0790787 3.56269 0.0466051 3.6441C0.0141316 3.72552 -0.001459 3.8127 0.000779152 3.90033C0.0030173 3.98796 0.023037 4.07422 0.0596247 4.15387C0.0962123 4.23352 0.148604 4.30492 0.21362 4.36371C0.278636 4.4225 0.354921 4.46747 0.437843 4.49588C0.520766 4.52429 0.608597 4.53555 0.696007 4.52899H0.700006Z" fill="#E80918"/></svg></button>',
        dots: false,
        responsive: [
          {
            breakpoint: 376,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }
    $('.home-promotion-section .block-list').slick({
      infinite: true,
      slidesToShow:2,
      slidesToScroll: 1,
      arrows:true,
      prevArrow:'<button class="custom-slick-prev custom-slick-arrow" type="button"><svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.543 4.52899H2.205L4.33 6.65399C4.45134 6.77533 4.51951 6.93988 4.51951 7.11148C4.51951 7.28308 4.45134 7.44766 4.33 7.569C4.20867 7.69034 4.0441 7.75848 3.8725 7.75848C3.70091 7.75848 3.53634 7.69034 3.415 7.569L1.48 5.63098L0.188005 4.33701C0.0679482 4.21601 0.000579834 4.05244 0.000579834 3.88199C0.000579834 3.71153 0.0679482 3.548 0.188005 3.427L3.415 0.196991C3.47508 0.136911 3.54641 0.0892471 3.62491 0.0567322C3.70341 0.0242172 3.78754 0.00747681 3.8725 0.00747681C3.95747 0.0074768 4.0416 0.0242172 4.1201 0.0567322C4.1986 0.0892471 4.26992 0.136911 4.33 0.196991C4.39008 0.257071 4.43774 0.328393 4.47026 0.406891C4.50277 0.485389 4.51951 0.569514 4.51951 0.65448C4.51951 0.739446 4.50277 0.823602 4.47026 0.9021C4.43774 0.980598 4.39008 1.05192 4.33 1.112L2.2 3.237H13.58C13.6676 3.23491 13.7548 3.25062 13.8361 3.28323C13.9175 3.31584 13.9914 3.36466 14.0533 3.4267C14.1153 3.48873 14.1639 3.56269 14.1964 3.6441C14.2289 3.72552 14.2445 3.8127 14.2422 3.90033C14.24 3.98796 14.22 4.07422 14.1834 4.15387C14.1468 4.23352 14.0944 4.30492 14.0294 4.36371C13.9644 4.4225 13.8881 4.46747 13.8052 4.49588C13.7222 4.52429 13.6344 4.53555 13.547 4.52899H13.543Z" fill="#E80918"/></svg></button>',
      nextArrow:'<button class="custom-slick-next custom-slick-arrow" type="button"><svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.700006 4.52899H12.038L9.91301 6.65399C9.79167 6.77533 9.7235 6.93988 9.7235 7.11148C9.7235 7.28308 9.79167 7.44766 9.91301 7.569C10.0343 7.69034 10.1989 7.75848 10.3705 7.75848C10.5421 7.75848 10.7067 7.69034 10.828 7.569L12.763 5.63098L14.055 4.33701C14.1751 4.21601 14.2424 4.05244 14.2424 3.88199C14.2424 3.71153 14.1751 3.548 14.055 3.427L10.828 0.196991C10.7679 0.136911 10.6966 0.0892471 10.6181 0.0567322C10.5396 0.0242172 10.4555 0.00747681 10.3705 0.00747681C10.2855 0.0074768 10.2014 0.0242172 10.1229 0.0567322C10.0444 0.0892471 9.97309 0.136911 9.91301 0.196991C9.85293 0.257071 9.80527 0.328393 9.77275 0.406891C9.74024 0.485389 9.7235 0.569514 9.7235 0.65448C9.7235 0.739446 9.74024 0.823602 9.77275 0.9021C9.80527 0.980598 9.85293 1.05192 9.91301 1.112L12.043 3.237H0.663007C0.575376 3.23491 0.488235 3.25062 0.406871 3.28323C0.325507 3.31584 0.251618 3.36466 0.189688 3.4267C0.127758 3.48873 0.0790787 3.56269 0.0466051 3.6441C0.0141316 3.72552 -0.001459 3.8127 0.000779152 3.90033C0.0030173 3.98796 0.023037 4.07422 0.0596247 4.15387C0.0962123 4.23352 0.148604 4.30492 0.21362 4.36371C0.278636 4.4225 0.354921 4.46747 0.437843 4.49588C0.520766 4.52429 0.608597 4.53555 0.696007 4.52899H0.700006Z" fill="#E80918"/></svg></button>',
      dots: false,
      responsive: [
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
 if ($(window).width() < 1000){
  homeProductList();  
 }

  var anchors = document.querySelectorAll('button[data-title]');
  for (var i = 0; i < anchors.length; i++) {
    anchors[i].addEventListener('click', function() {
      $(".product-list").slick('unslick');
      var targetId = this.getAttribute('data-title');
      var target = document.getElementById(targetId);
      if (target) {
        // Hide all target elements
        var allTargets = document.querySelectorAll('.target');
        for (var j = 0; j < allTargets.length; j++) {
          allTargets[j].style.display = 'none';
        }
        // Show the corresponding target element
        target.style.display = 'block';
      }
      homeProductList();
    });
  }
  
  var gt_img_attr = $(".gt_selected img").attr('alt');
   $('.gt_selected a').attr('data-gt-lang', gt_img_attr);

  $(".header-announcement-gtranslate .nturl").click(function(){
    var gt_img_attr1 = $(".gt_selected img").attr('alt');
   $('.gt_selected a').attr('data-gt-lang', gt_img_attr1);
  });

  $(".mobilesubmenu_arrow").click(function(){
    $(this).parent().next('ul').slideToggle();
    $(this).parent().toggleClass('active');
  });

  $('.view_job_dec').click( function() {
    var tabID = $(this).attr('data-job');
    $('#blockid_'+tabID).slideToggle();
  });

  $(".read-more-link").click(function(){
    $(this).parent().parent().addClass('active');
    $('.read-more-link').hide();
    $('.read-less-link').show();
  });
  $(".read-less-link").click(function(){
    $(this).parent().parent().removeClass('active');
    $('.read-more-link').show();
    $('.read-less-link').hide();
  });

  $(".mobile-filter").click(function(){
    $('.collection-menu-drawer').addClass('active');
    $('.collection-menu-overlay').addClass('active');
  });
  $(".collection-drawer-menu-close, .collection-menu-overlay").click(function(){
    $(".collection-menu-drawer").removeClass('active');
    $('.collection-menu-overlay').removeClass('active');
  });

  $('.gallery-slider.slider_active').slick({
    infinite: false,
    slidesToShow: 4.3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3.3
        }
      },
      {
        breakpoint: 841,
        settings: {
          slidesToShow: 2.3
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          arrows: true,
          dots: false,
          prevArrow:'<button class="custom-slick-prev custom-slick-arrow" type="button"><svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.543 4.52899H2.205L4.33 6.65399C4.45134 6.77533 4.51951 6.93988 4.51951 7.11148C4.51951 7.28308 4.45134 7.44766 4.33 7.569C4.20867 7.69034 4.0441 7.75848 3.8725 7.75848C3.70091 7.75848 3.53634 7.69034 3.415 7.569L1.48 5.63098L0.188005 4.33701C0.0679482 4.21601 0.000579834 4.05244 0.000579834 3.88199C0.000579834 3.71153 0.0679482 3.548 0.188005 3.427L3.415 0.196991C3.47508 0.136911 3.54641 0.0892471 3.62491 0.0567322C3.70341 0.0242172 3.78754 0.00747681 3.8725 0.00747681C3.95747 0.0074768 4.0416 0.0242172 4.1201 0.0567322C4.1986 0.0892471 4.26992 0.136911 4.33 0.196991C4.39008 0.257071 4.43774 0.328393 4.47026 0.406891C4.50277 0.485389 4.51951 0.569514 4.51951 0.65448C4.51951 0.739446 4.50277 0.823602 4.47026 0.9021C4.43774 0.980598 4.39008 1.05192 4.33 1.112L2.2 3.237H13.58C13.6676 3.23491 13.7548 3.25062 13.8361 3.28323C13.9175 3.31584 13.9914 3.36466 14.0533 3.4267C14.1153 3.48873 14.1639 3.56269 14.1964 3.6441C14.2289 3.72552 14.2445 3.8127 14.2422 3.90033C14.24 3.98796 14.22 4.07422 14.1834 4.15387C14.1468 4.23352 14.0944 4.30492 14.0294 4.36371C13.9644 4.4225 13.8881 4.46747 13.8052 4.49588C13.7222 4.52429 13.6344 4.53555 13.547 4.52899H13.543Z" fill="#E80918"/></svg></button>',
          nextArrow:'<button class="custom-slick-next custom-slick-arrow" type="button"><svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.700006 4.52899H12.038L9.91301 6.65399C9.79167 6.77533 9.7235 6.93988 9.7235 7.11148C9.7235 7.28308 9.79167 7.44766 9.91301 7.569C10.0343 7.69034 10.1989 7.75848 10.3705 7.75848C10.5421 7.75848 10.7067 7.69034 10.828 7.569L12.763 5.63098L14.055 4.33701C14.1751 4.21601 14.2424 4.05244 14.2424 3.88199C14.2424 3.71153 14.1751 3.548 14.055 3.427L10.828 0.196991C10.7679 0.136911 10.6966 0.0892471 10.6181 0.0567322C10.5396 0.0242172 10.4555 0.00747681 10.3705 0.00747681C10.2855 0.0074768 10.2014 0.0242172 10.1229 0.0567322C10.0444 0.0892471 9.97309 0.136911 9.91301 0.196991C9.85293 0.257071 9.80527 0.328393 9.77275 0.406891C9.74024 0.485389 9.7235 0.569514 9.7235 0.65448C9.7235 0.739446 9.74024 0.823602 9.77275 0.9021C9.80527 0.980598 9.85293 1.05192 9.91301 1.112L12.043 3.237H0.663007C0.575376 3.23491 0.488235 3.25062 0.406871 3.28323C0.325507 3.31584 0.251618 3.36466 0.189688 3.4267C0.127758 3.48873 0.0790787 3.56269 0.0466051 3.6441C0.0141316 3.72552 -0.001459 3.8127 0.000779152 3.90033C0.0030173 3.98796 0.023037 4.07422 0.0596247 4.15387C0.0962123 4.23352 0.148604 4.30492 0.21362 4.36371C0.278636 4.4225 0.354921 4.46747 0.437843 4.49588C0.520766 4.52429 0.608597 4.53555 0.696007 4.52899H0.700006Z" fill="#E80918"/></svg></button>'
        }
      },
      {
        breakpoint: 372,
        settings: {
          slidesToShow: 1,
          arrows: true,
          dots: false,
          prevArrow:'<button class="custom-slick-prev custom-slick-arrow" type="button"><svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.543 4.52899H2.205L4.33 6.65399C4.45134 6.77533 4.51951 6.93988 4.51951 7.11148C4.51951 7.28308 4.45134 7.44766 4.33 7.569C4.20867 7.69034 4.0441 7.75848 3.8725 7.75848C3.70091 7.75848 3.53634 7.69034 3.415 7.569L1.48 5.63098L0.188005 4.33701C0.0679482 4.21601 0.000579834 4.05244 0.000579834 3.88199C0.000579834 3.71153 0.0679482 3.548 0.188005 3.427L3.415 0.196991C3.47508 0.136911 3.54641 0.0892471 3.62491 0.0567322C3.70341 0.0242172 3.78754 0.00747681 3.8725 0.00747681C3.95747 0.0074768 4.0416 0.0242172 4.1201 0.0567322C4.1986 0.0892471 4.26992 0.136911 4.33 0.196991C4.39008 0.257071 4.43774 0.328393 4.47026 0.406891C4.50277 0.485389 4.51951 0.569514 4.51951 0.65448C4.51951 0.739446 4.50277 0.823602 4.47026 0.9021C4.43774 0.980598 4.39008 1.05192 4.33 1.112L2.2 3.237H13.58C13.6676 3.23491 13.7548 3.25062 13.8361 3.28323C13.9175 3.31584 13.9914 3.36466 14.0533 3.4267C14.1153 3.48873 14.1639 3.56269 14.1964 3.6441C14.2289 3.72552 14.2445 3.8127 14.2422 3.90033C14.24 3.98796 14.22 4.07422 14.1834 4.15387C14.1468 4.23352 14.0944 4.30492 14.0294 4.36371C13.9644 4.4225 13.8881 4.46747 13.8052 4.49588C13.7222 4.52429 13.6344 4.53555 13.547 4.52899H13.543Z" fill="#E80918"/></svg></button>',
          nextArrow:'<button class="custom-slick-next custom-slick-arrow" type="button"><svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.700006 4.52899H12.038L9.91301 6.65399C9.79167 6.77533 9.7235 6.93988 9.7235 7.11148C9.7235 7.28308 9.79167 7.44766 9.91301 7.569C10.0343 7.69034 10.1989 7.75848 10.3705 7.75848C10.5421 7.75848 10.7067 7.69034 10.828 7.569L12.763 5.63098L14.055 4.33701C14.1751 4.21601 14.2424 4.05244 14.2424 3.88199C14.2424 3.71153 14.1751 3.548 14.055 3.427L10.828 0.196991C10.7679 0.136911 10.6966 0.0892471 10.6181 0.0567322C10.5396 0.0242172 10.4555 0.00747681 10.3705 0.00747681C10.2855 0.0074768 10.2014 0.0242172 10.1229 0.0567322C10.0444 0.0892471 9.97309 0.136911 9.91301 0.196991C9.85293 0.257071 9.80527 0.328393 9.77275 0.406891C9.74024 0.485389 9.7235 0.569514 9.7235 0.65448C9.7235 0.739446 9.74024 0.823602 9.77275 0.9021C9.80527 0.980598 9.85293 1.05192 9.91301 1.112L12.043 3.237H0.663007C0.575376 3.23491 0.488235 3.25062 0.406871 3.28323C0.325507 3.31584 0.251618 3.36466 0.189688 3.4267C0.127758 3.48873 0.0790787 3.56269 0.0466051 3.6441C0.0141316 3.72552 -0.001459 3.8127 0.000779152 3.90033C0.0030173 3.98796 0.023037 4.07422 0.0596247 4.15387C0.0962123 4.23352 0.148604 4.30492 0.21362 4.36371C0.278636 4.4225 0.354921 4.46747 0.437843 4.49588C0.520766 4.52429 0.608597 4.53555 0.696007 4.52899H0.700006Z" fill="#E80918"/></svg></button>'
        }
      }
    ]
  });

  if ($(window).width() >= 1000){
    $('.services-subpage-productlist .product-list').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      prevArrow: $('.subpage-slick-prev'),
      nextArrow: $('.subpage-slick-next'),
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    });
  }else if($(window).width() <= 999){
    $('.services-subpage-productlist .product-list').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow:'<button class="custom-slick-prev custom-slick-arrow" type="button"><svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.543 4.52899H2.205L4.33 6.65399C4.45134 6.77533 4.51951 6.93988 4.51951 7.11148C4.51951 7.28308 4.45134 7.44766 4.33 7.569C4.20867 7.69034 4.0441 7.75848 3.8725 7.75848C3.70091 7.75848 3.53634 7.69034 3.415 7.569L1.48 5.63098L0.188005 4.33701C0.0679482 4.21601 0.000579834 4.05244 0.000579834 3.88199C0.000579834 3.71153 0.0679482 3.548 0.188005 3.427L3.415 0.196991C3.47508 0.136911 3.54641 0.0892471 3.62491 0.0567322C3.70341 0.0242172 3.78754 0.00747681 3.8725 0.00747681C3.95747 0.0074768 4.0416 0.0242172 4.1201 0.0567322C4.1986 0.0892471 4.26992 0.136911 4.33 0.196991C4.39008 0.257071 4.43774 0.328393 4.47026 0.406891C4.50277 0.485389 4.51951 0.569514 4.51951 0.65448C4.51951 0.739446 4.50277 0.823602 4.47026 0.9021C4.43774 0.980598 4.39008 1.05192 4.33 1.112L2.2 3.237H13.58C13.6676 3.23491 13.7548 3.25062 13.8361 3.28323C13.9175 3.31584 13.9914 3.36466 14.0533 3.4267C14.1153 3.48873 14.1639 3.56269 14.1964 3.6441C14.2289 3.72552 14.2445 3.8127 14.2422 3.90033C14.24 3.98796 14.22 4.07422 14.1834 4.15387C14.1468 4.23352 14.0944 4.30492 14.0294 4.36371C13.9644 4.4225 13.8881 4.46747 13.8052 4.49588C13.7222 4.52429 13.6344 4.53555 13.547 4.52899H13.543Z" fill="#E80918"/></svg></button>',
      nextArrow:'<button class="custom-slick-next custom-slick-arrow" type="button"><svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.700006 4.52899H12.038L9.91301 6.65399C9.79167 6.77533 9.7235 6.93988 9.7235 7.11148C9.7235 7.28308 9.79167 7.44766 9.91301 7.569C10.0343 7.69034 10.1989 7.75848 10.3705 7.75848C10.5421 7.75848 10.7067 7.69034 10.828 7.569L12.763 5.63098L14.055 4.33701C14.1751 4.21601 14.2424 4.05244 14.2424 3.88199C14.2424 3.71153 14.1751 3.548 14.055 3.427L10.828 0.196991C10.7679 0.136911 10.6966 0.0892471 10.6181 0.0567322C10.5396 0.0242172 10.4555 0.00747681 10.3705 0.00747681C10.2855 0.0074768 10.2014 0.0242172 10.1229 0.0567322C10.0444 0.0892471 9.97309 0.136911 9.91301 0.196991C9.85293 0.257071 9.80527 0.328393 9.77275 0.406891C9.74024 0.485389 9.7235 0.569514 9.7235 0.65448C9.7235 0.739446 9.74024 0.823602 9.77275 0.9021C9.80527 0.980598 9.85293 1.05192 9.91301 1.112L12.043 3.237H0.663007C0.575376 3.23491 0.488235 3.25062 0.406871 3.28323C0.325507 3.31584 0.251618 3.36466 0.189688 3.4267C0.127758 3.48873 0.0790787 3.56269 0.0466051 3.6441C0.0141316 3.72552 -0.001459 3.8127 0.000779152 3.90033C0.0030173 3.98796 0.023037 4.07422 0.0596247 4.15387C0.0962123 4.23352 0.148604 4.30492 0.21362 4.36371C0.278636 4.4225 0.354921 4.46747 0.437843 4.49588C0.520766 4.52429 0.608597 4.53555 0.696007 4.52899H0.700006Z" fill="#E80918"/></svg></button>',
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 841,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 376,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  $('.article-blog-grid .block-list').slick({
    infinite: true,
    slidesToShow:3,
    slidesToScroll: 1,
    prevArrow: $('.article-blog-grid .custom-slick-prev'),
    nextArrow: $('.article-blog-grid .custom-slick-next'),
    dots: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow:2,
          arrows:false,
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows:false,
          dots: true,
        }
      }
    ]
  });

  // upsell js in cart drawer
  $(document).on('click', '.upsell_products_drawer .addcart-btn',function(){
    var pro_id = $(this).data("pro-id");
    let arr = [];
    arr.push({id: pro_id, quantity: 1 });
    let formData = {'items': arr};
    fetch('/cart/add.js', {
      body: JSON.stringify(formData),
      credentials: 'same-origin',
      headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    }).then((response) => {
    return response.json();
    }).then((res) => {
      document.documentElement.dispatchEvent(new CustomEvent("cart:build"));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
     
    }).catch((err) => {
    
      console.error(err)
    });
  });

  $('body').on("cut", function(e) { 
    e.preventDefault(); 
  }); 

  $('body').on("copy", function(e) { 
    e.preventDefault(); 
  }); 
  $('body').on("paste", function(e) { 
    e.preventDefault(); 
  }); 

   $(document).on("contextmenu",function(e){
        e.preventDefault();
    });

});

// Home page Tab Section

  const button1 = document.querySelector('.header-button-group .button.button--primary');
  const button2 = document.querySelector('.header-button-group .button.button--secondary');
  const productsElement = document.querySelector(".product-list");
    
  if(button1){
    button1.addEventListener('click', function() {
      button1.classList.add('button--primary');
      button2.classList.remove('button--primary');
      button2.classList.add('button--secondary');
      if(button1.classList.contains("button--secondary")){
        button1.classList.remove('button--secondary');
      }
    });
  }
  if(button2){
    button2.addEventListener('click', function() {
      button2.classList.add('button--primary');
      button1.classList.remove('button--primary');
      button1.classList.add('button--secondary');
      if(button2.classList.contains("button--secondary")){
        button2.classList.remove('button--secondary');
      }
    });
  }

// Show opening hours in popup in mobile
const openingElement = document.querySelector(".openinghours_btn");
const popupOverlay = document.querySelector(".infopopup-overlay");
const popElement = document.querySelector(".infopopup");
const popClose = document.querySelector(".infopopup-popup-closeicon");
if(openingElement){
  openingElement.addEventListener('click',function () {
    popElement.classList.add('active');
    popupOverlay.classList.add('active');
  });
}
if(popClose){
  popClose.addEventListener('click',function(){
    popupOverlay.classList.remove('active');
    popElement.classList.remove('active');
  });
}

  // Product page shipping cutoff countdown (Europe/Zurich)
  function initShippingCutoffCountdown() {
    var countdownBlocks = document.querySelectorAll('[data-shipping-cutoff]');

    if (!countdownBlocks.length) {
      return;
    }

    var zurichFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Zurich',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });
    var weekdayNames = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

    function getZurichParts(date) {
      var values = {};
      zurichFormatter.formatToParts(date).forEach(function(part) {
        if (part.type !== 'literal') {
          values[part.type] = parseInt(part.value, 10);
        }
      });

      return values;
    }

    function addCalendarDays(year, month, day, daysToAdd) {
      var date = new Date(Date.UTC(year, month - 1, day + daysToAdd));

      return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        day: date.getUTCDate()
      };
    }

    function zurichDateTimeToEpoch(year, month, day, hour, minute, second) {
      var desiredAsUtc = Date.UTC(year, month - 1, day, hour, minute, second);
      var guess = desiredAsUtc;

      for (var attempt = 0; attempt < 3; attempt += 1) {
        var actual = getZurichParts(new Date(guess));
        var actualAsUtc = Date.UTC(
          actual.year,
          actual.month - 1,
          actual.day,
          actual.hour,
          actual.minute,
          actual.second
        );
        guess += desiredAsUtc - actualAsUtc;
      }

      return guess;
    }

    function getSchedule(now) {
      var current = getZurichParts(now);
      var weekday = new Date(Date.UTC(current.year, current.month - 1, current.day)).getUTCDay();
      var isWeekday = weekday >= 1 && weekday <= 5;
      var isBeforeCutoff = current.hour < 18;
      var daysToAdd = 0;
      var isToday = isWeekday && isBeforeCutoff;

      if (!isToday) {
        if (weekday === 5) {
          daysToAdd = 3;
        } else if (weekday === 6) {
          daysToAdd = 2;
        } else if (weekday === 0) {
          daysToAdd = 1;
        } else {
          daysToAdd = 1;
        }
      }

      var targetDate = addCalendarDays(current.year, current.month, current.day, daysToAdd);
      var targetWeekday = new Date(Date.UTC(targetDate.year, targetDate.month - 1, targetDate.day)).getUTCDay();

      return {
        label: isToday
          ? 'Versand heute bei Bestellung innerhalb von'
          : 'Versand ' + weekdayNames[targetWeekday] + ' · Countdown bis 18:00 Uhr:',
        targetEpoch: zurichDateTimeToEpoch(targetDate.year, targetDate.month, targetDate.day, 18, 0, 0)
      };
    }

    function formatRemaining(milliseconds) {
      var totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      return String(hours).padStart(2, '0') + ':' +
        String(minutes).padStart(2, '0') + ':' +
        String(seconds).padStart(2, '0');
    }

    countdownBlocks.forEach(function(block) {
      if (block.dataset.shippingCountdownReady === 'true') {
        return;
      }

      block.dataset.shippingCountdownReady = 'true';
      var labelElement = block.querySelector('[data-shipping-label]');
      var countdownElement = block.querySelector('[data-shipping-countdown]');
      var schedule = getSchedule(new Date());

      function updateCountdown() {
        var now = new Date();

        if (now.getTime() >= schedule.targetEpoch) {
          schedule = getSchedule(now);
        }

        labelElement.textContent = schedule.label;
        countdownElement.textContent = formatRemaining(schedule.targetEpoch - now.getTime());
      }

      updateCountdown();
      window.setInterval(updateCountdown, 1000);
    });
  }

  initShippingCutoffCountdown();

  // product card - qty selector -- JS -- START
  let qtyBtns = document.querySelectorAll("[data-card-qty-wrapper] [data-card-qty-btn]");
  if(qtyBtns.length){
    qtyBtns.forEach(btn => {
      btn.addEventListener("click", function(e) {
        e.preventDefault();
        let parent = btn.closest("[data-card-qty-wrapper]");
        let type =  btn.getAttribute("data-type");
        let input = parent.querySelector("[data-card-qty-input]");
        if(type == "decrease-qty"){
          if(parseInt(input.value) != 1){
            input.value = parseInt(input.value) - 1;
          }
        }else{
          input.value = parseInt(input.value) + 1;
        }
      })
    });
  }

  // product card - qty selector -- JS -- END
  let thumbnailSlider = document.querySelectorAll(".home-logo-slider .quick-links");
  if(thumbnailSlider.length){
    thumbnailSlider.forEach(ele => {
      eleSlider = new import_flickity.default(ele, {
        watchCSS: false,
        draggble: true,
        prevNextButtons: false,
        autoPlay: true,
        contain: true,
        freeScroll: false,
        pageDots: true,
        groupCells: true,
        wrapAround: true,
        cellAlign: 'left'
      });
    });
  }
